import {
  Box,
  Card,
  CardFooter,
  CardHeader,
  Skeleton
} from "@prismicio/editor-ui"
import type { ReactNode } from "react"

interface ReleasePageHeaderProps {
  title: ReactNode
  actions: ReactNode
  indicator?: ReactNode
  footer?: ReactNode
}

export function ReleasePageHeader(props: ReleasePageHeaderProps) {
  const { actions, footer, title } = props

  return (
    <Card paddingBlock={28} paddingInline={24}>
      <CardHeader>
        <Box gap={4} alignItems="center" flexGrow={1}>
          {title}
        </Box>

        {actions}
      </CardHeader>
      {footer && <CardFooter>{footer}</CardFooter>}
    </Card>
  )
}

export function ReleasePageHeaderSkeleton() {
  return (
    <Card paddingBlock={28} paddingInline={24}>
      <CardHeader>
        <Skeleton width={200} height={30} />
        <Skeleton
          sx={{
            flexGrow: 1
          }}
        />
        <Box gap={8}>
          <Skeleton key="release-date" width={159} height={40} />
          <Skeleton key="delete" width={100} height={40} />
          <Skeleton key="preview" width={135} height={40} />
        </Box>
      </CardHeader>
    </Card>
  )
}
